import { Text, FormControl, FormLabel, Textarea } from '@chakra-ui/react';

function setPageDescription({ e, editPageProps, setEditPageProps }) {
	const value = e.target.value;
	const newPageInfo = { ...editPageProps };
	newPageInfo.pageDescription = value;
	setEditPageProps(newPageInfo);
}

const EditPageDescription = ({ editPageProps, setEditPageProps }) => {
	return (
		<FormControl mb={2}>
			<FormLabel fontSize={'sm'} pb={2} m={0} fontWeight={'500'}>
				Descrição
			</FormLabel>
			<Textarea
				onChange={(e) => setPageDescription({ e, editPageProps, setEditPageProps })}
				px={3}
				borderRadius={'lg'}
				value={editPageProps.pageDescription ? editPageProps.pageDescription : ''}
				fontSize={'sm'}
				placeholder={'Digite aqui... (Max. 255 caracteres)'}
			></Textarea>
			<Text fontSize={'sm'} color={'gray.500'}>
				*Documente as funcionalidades aqui
			</Text>
		</FormControl>
	);
};

export default EditPageDescription;
